export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/app/editor": [5,[2]],
		"/app/shop/buy": [6,[2]],
		"/app/shop/cancel": [7,[2]],
		"/app/shop/downgrade": [8,[2]],
		"/app/shop/success": [9,[2]],
		"/app/sign/forgot": [10,[2,3]],
		"/app/sign/login": [11,[2,3]],
		"/app/sign/privacy": [12,[2,3]],
		"/app/sign/register": [13,[2,3]],
		"/app/success": [14,[2]],
		"/check": [15],
		"/home/pricing": [16]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';